/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

export const FirstNameFormatter = (cellContent, row, rowIndex) => {
  const { firstname } = row;
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {firstname ? firstname : "-"}
      </div>
      <> </>
    </>
  );
};
